import React from 'react';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';

function FormsPersonalInfo(props: {formik: any}): React.ReactElement {
  const { formik } = props;
  return (
    <form
      aria-label="form"
      onSubmit={formik.handleSubmit}
      className="form-container"
    >
      <div className="row">
        <div className="col-lg-6">
          <Form.Default
            id="firstname"
            label="First Name"
            placeholder="Enter first name"
            value={formik.values.firstname}
            onChange={formik.handleChange}
            className="mb-4"
            isInvalid={formik.touched.firstname && !!formik.errors.firstname}
            errorMsg={formik.errors.firstname}
            onBlur={formik.handleBlur}
            validation
          />
        </div>
        <div className="col-lg-6">
          <Form.Default
            id="lastname"
            label="Last Name"
            placeholder="Enter last name"
            value={formik.values.lastname}
            onChange={formik.handleChange}
            className="mb-4"
            isInvalid={formik.touched.lastname && !!formik.errors.lastname}
            errorMsg={formik.errors.lastname}
            onBlur={formik.handleBlur}
            validation
          />
        </div>
      </div>
      <Form.Default
        id="phoneNumber"
        label="Phone Number"
        placeholder="Enter phone number"
        value={formik.values.phoneNumber}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
        errorMsg={formik.errors.phoneNumber}
        onBlur={formik.handleBlur}
        validation
      />
      <Form.Default
        id="position"
        label="Position"
        placeholder="Enter position"
        value={formik.values.position}
        onChange={formik.handleChange}
        className="mb-4"
        isInvalid={formik.touched.position && !!formik.errors.position}
        errorMsg={formik.errors.position}
        onBlur={formik.handleBlur}
        validation
      />
      <div className="mt-5">
        <Button.Default
          id="buttonPersonalInfo"
          type="submit"
          label="Next"
          className="fw-bold"
        />
      </div>
    </form>
  );
}

export default FormsPersonalInfo;
